import Slash from '../../Slash'
import "../CampusSlashTitle/CampusSlashTitle.scss"

const CampusSlashTitle = ({slashTitle}) => {
  return (
    <>
     <div className='campus-slash-title' style={{paddingBottom:(slashTitle === "Entrepreneurship Development Cell" || slashTitle === "ICT Academy of Tamil Nadu" || slashTitle === "Institution Innovation Council" || slashTitle === "TNSTC/Naan Mudhalvan" || slashTitle === "SWAYAM / NPTEL / MOOC") && "0"}}>
          <div><h2>{slashTitle}</h2></div>
          <div className='campus-slash'>
           <Slash />
          </div>
        </div>
    </>
  )
}

export default CampusSlashTitle